import { VStack } from "@chakra-ui/react"
import { PathItemType } from "@pathwright/graphql-client/src/generated"
import PreviewPathDivider from "../../path/preview/PreviewPathDivider"
import PreviewPathLesson from "../../path/preview/PreviewPathLesson"
import PreviewPathResource from "../../path/preview/PreviewPathResource"
import { PathItems } from "./types"

export default function PreviewCollectionPath({ items }: { items: PathItems }) {
  return (
    <VStack align="stretch" gap={5}>
      {items.map((item) =>
        item.type === PathItemType.Resource ? (
          <PreviewPathResource key={item.id} pathItem={item} layout="list" />
        ) : item.type === PathItemType.Divider ? (
          <PreviewPathDivider key={item.id} pathItem={item} />
        ) : item.type === PathItemType.Lesson ? (
          <PreviewPathLesson key={item.id} pathItem={item} />
        ) : null
      )}
    </VStack>
  )
}
